export default {
    cols: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12auto".includes(value);
        },
        default: null,
    },
    xl: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12auto".includes(value);
        },
        default: null,
    },
    lg: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12auto".includes(value);
        },
        default: null,
    },
    md: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12auto".includes(value);
        },
        default: null,
    },
    sm: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12auto".includes(value);
        },
        default: null,
    },
    alignSelf: {
        type: String,
        validator(value) {
            return ["start", "center", "end", "baseline", "stretch"].includes(
                value
            );
        },
        default: null,
    },
    order: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12".includes(value);
        },
        default: null,
    },
    offset: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12".includes(value);
        },
        default: null,
    },
    offsetXl: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12".includes(value);
        },
        default: null,
    },
    offsetLg: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12".includes(value);
        },
        default: null,
    },
    offsetMd: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12".includes(value);
        },
        default: null,
    },
    offsetSm: {
        type: String,
        validator(value) {
            return "1 23456789 10 11 12".includes(value);
        },
        default: null,
    },
};
